import type { SVGProps } from 'react';

const SvgEdit = (props: SVGProps<SVGSVGElement>) => (
  <svg
    fill='none'
    height='1em'
    viewBox='0 0 24 24'
    width='1em'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <path
      clipRule='evenodd'
      d='M21.32 19.946a.75.75 0 0 1-.75.75H14.45a.75.75 0 0 1 0-1.5h6.122a.75.75 0 0 1 .75.75Z'
      fill='currentColor'
      fillRule='evenodd'
      opacity={0.3}
    />
    <path
      d='M16.924 4.335a1.998 1.998 0 0 0-2.827.002l-1.663 1.665 5.34 5.34 1.66-1.702a2.002 2.002 0 0 0-.018-2.813l-2.492-2.492Z'
      fill='currentColor'
    />
    <path
      d='m16.73 12.42-5.354-5.354-6.577 6.587a3.002 3.002 0 0 0-.875 1.995l-.118 2.81a1.5 1.5 0 0 0 1.498 1.563h2.752c.809 0 1.583-.326 2.147-.905l6.526-6.696Z'
      fill='currentColor'
      opacity={0.3}
    />
  </svg>
);
export default SvgEdit;
